import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConsolidatedTransactionRequestModel } from '../../../../shared/models/transactions-model';

@Component({
	selector: 'app-kamona-table-filter',
	templateUrl: './kamona-table-filter.component.html',
	styleUrls: ['./kamona-table-filter.component.scss']
})
export class KamonaTableFilterComponent implements OnInit {
	searchParams: Map<string, any> = new Map();
	@Output() emitSearchParams = new EventEmitter();
	@Input() params: ConsolidatedTransactionRequestModel;

	constructor() {
	}

	ngOnInit(): void {

	}


}
